import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  actions: {
  },
  mutations: {
    status(state, value) {
      state.status = value;
    },
    onFilters(state, data) {
      switch (data.type) {
        case 'status':
          state.filters.status = data.amount;
          break;
        case 'price':
          state.filters.price = data.amount;
          break;
        case 'sector':
          state.filters.sector = data.amount;
          break;
        case 'title':
          state.filters.title = data.amount;
          break;
        case 'city':
          state.filters.city = data.amount;
          break;
        case 'place':
          state.filters.place = data.amount;
          break;
        case 'calendar':
          state.filters.calendar = data.amount;
          break;
        default:
          break;
      }
    },
    onSidebar(state, data) {
      if(!data) {
        state.sidebar = false;
        return false;
      }
      if(!isNaN(data)){
        if(data < 1200) {
          state.sidebar = false;
        } else {
          state.sidebar = true;
        }
      } else {
        state.sidebar = !state.sidebar;
      }
    },
    viewInfoInTable(state, data){
      let el = data.el;
      let allSumm = data.allSumm;
      let allPlace = data.allPlace;
      let allRow = data.visibleRow;
      let priceArr = data.priceArr;
      let allStatus = data.allStatus;
      state.sectors.forEach(item => {
        if (item.scheme === null) return
        item.scheme.forEach(el => {
          el.places.forEach(place => {
            if(allPlace === undefined) {
              place.isActive = false
            }
          })
        })
      })
      if (allStatus === undefined) {
        allStatus = []
        el.scheme.forEach(item => {
          item.places.forEach(place => {
            if (!allStatus.includes(place.status) && place.status !== '') {
              allStatus.push(place.status)
            }
          })
        })
      }
      if(allSumm === undefined || allPlace === undefined || priceArr === undefined)  {
        allPlace = 0
        allSumm = 0
        priceArr = []
        el.scheme.forEach(item => {
          allPlace += parseInt(item.places.length)
          item.places.forEach(place => {
            if (!isNaN(parseInt(place.price))) {
              allSumm += parseInt(place.price)
              if (!priceArr.includes(parseInt(place.price))) {
                priceArr.push(parseInt(place.price))
              }
            }
          })
        })
      }
      if(allRow === undefined) {
        let rows = []
        el.scheme.forEach(item => {
          rows.push(item.id)
        })
        allRow = rows
      }

      state.sectors.forEach(item => {
        if (item.id === el.id) {
          item.summ = allSumm
          item.place = allPlace
          item.row = allRow
          item.price = priceArr
          item.status = allStatus
        }
      })
    },
    sortingPrice(state, sectors) {
      state.priceAll = ['Любая']
      sectors.forEach(s => {
        for (let str of s.price) {
          if (!state.priceAll.includes(str.toString())) {
            state.priceAll.push(str.toString());
          }
        }
      })
      state.priceAll.sort(function(a, b) {
        return a - b;
      });
    },
    sortingName(state, sectors) {
      state.sectorAll = ['Любой']
      sectors.forEach(s => {
        if (!state.sectorAll.includes(s.name)) {
          state.sectorAll.push(s.name);
        }
      })
      state.sectorAll.sort(sortFn);
    },
    sortingStatus(state, sectors) {
      state.statusAll = ['Любой']
      sectors.forEach(s => {
        for (let str of s.status) {
          if (!state.statusAll.includes(convertStatus(str))) {
            state.statusAll.push(convertStatus(str));
          }
        }
      })
      state.statusAll.sort(sortFn);
    },
  },

  state: {
    filters: {
      status: null,
      price: null,
      sector: null,
      sort: null,
      title: null,
      place: null,
      calendar: null,
    },
    sidebar: true,
    requisites: true,
    hours: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
    minutes: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
    cities: ['Все', 'Санкт-Петербург', 'Москва', 'Екатеринбург', 'Казань'],
    activityPlace: ['Все', '“Парк водных аттракционов АКВАЛОО" (ул. Декабристов, 78Б )', 'Библиотека-читальня им. И.С. Тургенева (Бобров пер., 6, стр. 1)', 'г. Санкт-Петербург, ул. Большая Зеленина дом 3 (ул. Большая Зеленина дом 3)', 'ГАУ ЯО «Дворец молодёжи»  (г. Ярославль, пр. Ленина, 27)', 'Колизей Арена'],
    sectors: [
      {
        id: 1,
        name: 'Сектор А',
        type: 'Сектор с местом',
        row: [1, 2, 3],
        place: 99,
        price: ['1500', '3000'],
        summ: 117000,
        status: ['sale'],
        scheme: [{"id":1,"places":[{"id":1,"price":"3000","isActive":false,"status":"sale"},{"id":2,"price":"3000","isActive":false,"status":"sale"},{"id":3,"price":"3000","isActive":false,"status":"sale"},{"id":4,"price":"3000","isActive":false,"status":"sale"},{"id":5,"price":"3000","isActive":false,"status":"sale"},{"id":6,"price":"3000","isActive":false,"status":"sale"},{"id":7,"price":"3000","isActive":false,"status":"sale"},{"id":8,"price":"3000","isActive":false,"status":"sale"},{"id":9,"price":"3000","isActive":false,"status":"sale"},{"id":10,"price":"3000","isActive":false,"status":"sale"},{"id":11,"price":"3000","isActive":false,"status":"sale"},{"id":12,"price":"3000","isActive":false,"status":"sale"},{"id":13,"price":"3000","isActive":false,"status":"sale"},{"id":14,"price":"3000","isActive":false,"status":"sale"},{"id":15,"price":"3000","isActive":false,"status":"sale"},{"id":16,"price":"-","isActive":false,"status":""},{"id":17,"price":"-","isActive":false,"status":""},{"id":18,"price":"-","isActive":false,"status":""},{"id":19,"price":"-","isActive":false,"status":""},{"id":20,"price":"-","isActive":false,"status":""},{"id":21,"price":"-","isActive":false,"status":""},{"id":22,"price":"-","isActive":false,"status":""},{"id":23,"price":"-","isActive":false,"status":""},{"id":24,"price":"-","isActive":false,"status":""},{"id":25,"price":"-","isActive":false,"status":""},{"id":26,"price":"-","isActive":false,"status":""},{"id":27,"price":"-","isActive":false,"status":""},{"id":28,"price":"-","isActive":false,"status":""},{"id":29,"price":"-","isActive":false,"status":""},{"id":30,"price":"-","isActive":false,"status":""},{"id":31,"price":"-","isActive":false,"status":""},{"id":32,"price":"-","isActive":false,"status":""},{"id":33,"price":"-","isActive":false,"status":""},{"id":34,"price":"-","isActive":false,"status":""},{"id":35,"price":"-","isActive":false,"status":""},{"id":36,"price":"-","isActive":false,"status":""},{"id":37,"price":"-","isActive":false,"status":""},{"id":38,"price":"-","isActive":false,"status":""},{"id":39,"price":"-","isActive":false,"status":""},{"id":40,"price":"-","isActive":false,"status":""},{"id":41,"price":"-","isActive":false,"status":""},{"id":42,"price":"-","isActive":false,"status":""},{"id":43,"price":"-","isActive":false,"status":""},{"id":44,"price":"-","isActive":false,"status":""},{"id":45,"price":"-","isActive":false,"status":""},{"id":46,"price":"-","isActive":false,"status":""},{"id":47,"price":"-","isActive":false,"status":""},{"id":48,"price":"-","isActive":false,"status":""},{"id":49,"price":"-","isActive":false,"status":""},{"id":50,"price":"-","isActive":false,"status":""}]},{"id":2,"places":[{"id":1,"price":"2000","isActive":false,"status":"sale"},{"id":2,"price":"2000","isActive":false,"status":"sale"},{"id":3,"price":"2000","isActive":false,"status":"sale"},{"id":4,"price":"2000","isActive":false,"status":"sale"},{"id":5,"price":"2000","isActive":false,"status":"sale"},{"id":6,"price":"2000","isActive":false,"status":"sale"},{"id":7,"price":"2000","isActive":false,"status":"sale"},{"id":8,"price":"2000","isActive":false,"status":"sale"},{"id":9,"price":"2000","isActive":false,"status":"sale"},{"id":10,"price":"2000","isActive":false,"status":"sale"},{"id":11,"price":"2000","isActive":false,"status":"sale"},{"id":12,"price":"2000","isActive":false,"status":"sale"},{"id":13,"price":"2000","isActive":false,"status":"sale"},{"id":14,"price":"2000","isActive":false,"status":"sale"},{"id":15,"price":"2000","isActive":false,"status":"sale"},{"id":16,"price":"2000","isActive":false,"status":"sale"},{"id":17,"price":"2000","isActive":false,"status":"sale"},{"id":18,"price":"2000","isActive":false,"status":"sale"},{"id":19,"price":"2000","isActive":false,"status":"sale"},{"id":20,"price":"2000","isActive":false,"status":"sale"},{"id":21,"price":"2000","isActive":false,"status":"sale"},{"id":22,"price":"2000","isActive":false,"status":"sale"},{"id":23,"price":"2000","isActive":false,"status":"sale"},{"id":24,"price":"2000","isActive":false,"status":"sale"},{"id":25,"price":"-","isActive":false,"status":""},{"id":26,"price":"-","isActive":false,"status":""},{"id":27,"price":"-","isActive":false,"status":""},{"id":28,"price":"-","isActive":false,"status":""},{"id":29,"price":"-","isActive":false,"status":""}]},{"id":3,"places":[{"id":1,"price":"1500","isActive":false,"status":"sale"},{"id":2,"price":"1500","isActive":false,"status":"sale"},{"id":3,"price":"1500","isActive":false,"status":"sale"},{"id":4,"price":"1500","isActive":false,"status":"sale"},{"id":5,"price":"1500","isActive":false,"status":"sale"},{"id":6,"price":"1500","isActive":false,"status":"sale"},{"id":7,"price":"1500","isActive":false,"status":"sale"},{"id":8,"price":"1500","isActive":false,"status":"sale"},{"id":9,"price":"1500","isActive":false,"status":"sale"},{"id":10,"price":"1500","isActive":false,"status":"sale"},{"id":11,"price":"1500","isActive":false,"status":"sale"},{"id":12,"price":"1500","isActive":false,"status":"sale"},{"id":13,"price":"1500","isActive":false,"status":"sale"},{"id":14,"price":"1500","isActive":false,"status":"sale"},{"id":15,"price":"1500","isActive":false,"status":"sale"},{"id":16,"price":"1500","isActive":false,"status":"sale"},{"id":17,"price":"-","isActive":false,"status":""},{"id":18,"price":"-","isActive":false,"status":""},{"id":19,"price":"-","isActive":false,"status":""},{"id":20,"price":"-","isActive":false,"status":""}]}],
        visible: true,
        check: false,
      },
      {
        id: 2,
        name: 'Сектор №2',
        type: 'Сектор с местом',
        row: 1,
        place: 50,
        price: ['3000'],
        summ: 45000,
        status: ['hide'],
        scheme: [{"id":1,"places":[{"id":1,"price":"3000","isActive":false,"status":"hide"},{"id":2,"price":"3000","isActive":false,"status":"hide"},{"id":3,"price":"3000","isActive":false,"status":"hide"},{"id":4,"price":"3000","isActive":false,"status":"hide"},{"id":5,"price":"3000","isActive":false,"status":"hide"},{"id":6,"price":"3000","isActive":false,"status":"hide"},{"id":7,"price":"3000","isActive":false,"status":"hide"},{"id":8,"price":"3000","isActive":false,"status":"hide"},{"id":9,"price":"3000","isActive":false,"status":"hide"},{"id":10,"price":"3000","isActive":false,"status":"hide"},{"id":11,"price":"3000","isActive":false,"status":"hide"},{"id":12,"price":"3000","isActive":false,"status":"hide"},{"id":13,"price":"3000","isActive":false,"status":"hide"},{"id":14,"price":"3000","isActive":false,"status":"hide"},{"id":15,"price":"3000","isActive":false,"status":"hide"},{"id":16,"price":"-","isActive":false,"status":""},{"id":17,"price":"-","isActive":false,"status":""},{"id":18,"price":"-","isActive":false,"status":""},{"id":19,"price":"-","isActive":false,"status":""},{"id":20,"price":"-","isActive":false,"status":""},{"id":21,"price":"-","isActive":false,"status":""},{"id":22,"price":"-","isActive":false,"status":""},{"id":23,"price":"-","isActive":false,"status":""},{"id":24,"price":"-","isActive":false,"status":""},{"id":25,"price":"-","isActive":false,"status":""},{"id":26,"price":"-","isActive":false,"status":""},{"id":27,"price":"-","isActive":false,"status":""},{"id":28,"price":"-","isActive":false,"status":""},{"id":29,"price":"-","isActive":false,"status":""},{"id":30,"price":"-","isActive":false,"status":""},{"id":31,"price":"-","isActive":false,"status":""},{"id":32,"price":"-","isActive":false,"status":""},{"id":33,"price":"-","isActive":false,"status":""},{"id":34,"price":"-","isActive":false,"status":""},{"id":35,"price":"-","isActive":false,"status":""},{"id":36,"price":"-","isActive":false,"status":""},{"id":37,"price":"-","isActive":false,"status":""},{"id":38,"price":"-","isActive":false,"status":""},{"id":39,"price":"-","isActive":false,"status":""},{"id":40,"price":"-","isActive":false,"status":""},{"id":41,"price":"-","isActive":false,"status":""},{"id":42,"price":"-","isActive":false,"status":""},{"id":43,"price":"-","isActive":false,"status":""},{"id":44,"price":"-","isActive":false,"status":""},{"id":45,"price":"-","isActive":false,"status":""},{"id":46,"price":"-","isActive":false,"status":""},{"id":47,"price":"-","isActive":false,"status":""},{"id":48,"price":"-","isActive":false,"status":""},{"id":49,"price":"-","isActive":false,"status":""},{"id":50,"price":"-","isActive":false,"status":""}]}],
        visible: true,
        check: false,
      },
      {
        id: 3,
        name: 'Выходные билеты',
        type: 'Сектор без места',
        row: null,
        place: 200,
        price: ['2000'],
        summ: 120000,
        status: ['saled'],
        scheme: [{"id":1,"places":[{"id":1,"price":"2000","isActive":false,"status":"saled"},{"id":2,"price":"2000","isActive":false,"status":"saled"},{"id":3,"price":"2000","isActive":false,"status":"saled"},{"id":4,"price":"2000","isActive":false,"status":"saled"},{"id":5,"price":"2000","isActive":false,"status":"saled"},{"id":6,"price":"2000","isActive":false,"status":"saled"},{"id":7,"price":"2000","isActive":false,"status":"saled"},{"id":8,"price":"2000","isActive":false,"status":"saled"},{"id":9,"price":"2000","isActive":false,"status":"saled"},{"id":10,"price":"2000","isActive":false,"status":"saled"},{"id":11,"price":"2000","isActive":false,"status":"saled"},{"id":12,"price":"2000","isActive":false,"status":"saled"},{"id":13,"price":"2000","isActive":false,"status":"saled"},{"id":14,"price":"2000","isActive":false,"status":"saled"},{"id":15,"price":"2000","isActive":false,"status":"saled"},{"id":16,"price":"2000","isActive":false,"status":"saled"},{"id":17,"price":"2000","isActive":false,"status":"saled"},{"id":18,"price":"2000","isActive":false,"status":"saled"},{"id":19,"price":"2000","isActive":false,"status":"saled"},{"id":20,"price":"2000","isActive":false,"status":"saled"},{"id":21,"price":"2000","isActive":false,"status":"saled"},{"id":22,"price":"2000","isActive":false,"status":"saled"},{"id":23,"price":"2000","isActive":false,"status":"saled"},{"id":24,"price":"2000","isActive":false,"status":"saled"},{"id":25,"price":"2000","isActive":false,"status":"saled"},{"id":26,"price":"2000","isActive":false,"status":"saled"},{"id":27,"price":"2000","isActive":false,"status":"saled"},{"id":28,"price":"2000","isActive":false,"status":"saled"},{"id":29,"price":"2000","isActive":false,"status":"saled"},{"id":30,"price":"2000","isActive":false,"status":"saled"},{"id":31,"price":"2000","isActive":false,"status":"saled"},{"id":32,"price":"2000","isActive":false,"status":"saled"},{"id":33,"price":"2000","isActive":false,"status":"saled"},{"id":34,"price":"2000","isActive":false,"status":"saled"},{"id":35,"price":"2000","isActive":false,"status":"saled"},{"id":36,"price":"2000","isActive":false,"status":"saled"},{"id":37,"price":"2000","isActive":false,"status":"saled"},{"id":38,"price":"2000","isActive":false,"status":"saled"},{"id":39,"price":"2000","isActive":false,"status":"saled"},{"id":40,"price":"2000","isActive":false,"status":"saled"},{"id":41,"price":"2000","isActive":false,"status":"saled"},{"id":42,"price":"2000","isActive":false,"status":"saled"},{"id":43,"price":"2000","isActive":false,"status":"saled"},{"id":44,"price":"2000","isActive":false,"status":"saled"},{"id":45,"price":"2000","isActive":false,"status":"saled"},{"id":46,"price":"2000","isActive":false,"status":"saled"},{"id":47,"price":"2000","isActive":false,"status":"saled"},{"id":48,"price":"2000","isActive":false,"status":"saled"},{"id":49,"price":"2000","isActive":false,"status":"saled"},{"id":50,"price":"2000","isActive":false,"status":"saled"},{"id":51,"price":"2000","isActive":false,"status":"saled"},{"id":52,"price":"2000","isActive":false,"status":"saled"},{"id":53,"price":"2000","isActive":false,"status":"saled"},{"id":54,"price":"2000","isActive":false,"status":"saled"},{"id":55,"price":"2000","isActive":false,"status":"saled"},{"id":56,"price":"2000","isActive":false,"status":"saled"},{"id":57,"price":"2000","isActive":false,"status":"saled"},{"id":58,"price":"2000","isActive":false,"status":"saled"},{"id":59,"price":"2000","isActive":false,"status":"saled"},{"id":60,"price":"2000","isActive":false,"status":"saled"},{"id":61,"price":"2000","isActive":false,"status":"saled"},{"id":62,"price":"2000","isActive":false,"status":"saled"},{"id":63,"price":"2000","isActive":false,"status":"saled"},{"id":64,"price":"2000","isActive":false,"status":"saled"},{"id":65,"price":"2000","isActive":false,"status":"saled"},{"id":66,"price":"2000","isActive":false,"status":"saled"},{"id":67,"price":"2000","isActive":false,"status":"saled"},{"id":68,"price":"2000","isActive":false,"status":"saled"},{"id":69,"price":"2000","isActive":false,"status":"saled"},{"id":70,"price":"2000","isActive":false,"status":"saled"},{"id":71,"price":"2000","isActive":false,"status":"saled"},{"id":72,"price":"2000","isActive":false,"status":"saled"},{"id":73,"price":"2000","isActive":false,"status":"saled"},{"id":74,"price":"2000","isActive":false,"status":"saled"},{"id":75,"price":"2000","isActive":false,"status":"saled"},{"id":76,"price":"2000","isActive":false,"status":"saled"},{"id":77,"price":"2000","isActive":false,"status":"saled"},{"id":78,"price":"2000","isActive":false,"status":"saled"},{"id":79,"price":"2000","isActive":false,"status":"saled"},{"id":80,"price":"2000","isActive":false,"status":"saled"},{"id":81,"price":"2000","isActive":false,"status":"saled"},{"id":82,"price":"2000","isActive":false,"status":"saled"},{"id":83,"price":"2000","isActive":false,"status":"saled"},{"id":84,"price":"2000","isActive":false,"status":"saled"},{"id":85,"price":"2000","isActive":false,"status":"saled"},{"id":86,"price":"2000","isActive":false,"status":"saled"},{"id":87,"price":"2000","isActive":false,"status":"saled"},{"id":88,"price":"2000","isActive":false,"status":"saled"},{"id":89,"price":"2000","isActive":false,"status":"saled"},{"id":90,"price":"2000","isActive":false,"status":"saled"},{"id":91,"price":"2000","isActive":false,"status":"saled"},{"id":92,"price":"2000","isActive":false,"status":"saled"},{"id":93,"price":"2000","isActive":false,"status":"saled"},{"id":94,"price":"2000","isActive":false,"status":"saled"},{"id":95,"price":"2000","isActive":false,"status":"saled"},{"id":96,"price":"2000","isActive":false,"status":"saled"},{"id":97,"price":"2000","isActive":false,"status":"saled"},{"id":98,"price":"2000","isActive":false,"status":"saled"},{"id":99,"price":"2000","isActive":false,"status":"saled"},{"id":100,"price":"2000","isActive":false,"status":"saled"},{"id":101,"price":"2000","isActive":false,"status":"saled"},{"id":102,"price":"2000","isActive":false,"status":"saled"},{"id":103,"price":"2000","isActive":false,"status":"saled"},{"id":104,"price":"2000","isActive":false,"status":"saled"},{"id":105,"price":"2000","isActive":false,"status":"saled"},{"id":106,"price":"2000","isActive":false,"status":"saled"},{"id":107,"price":"2000","isActive":false,"status":"saled"},{"id":108,"price":"2000","isActive":false,"status":"saled"},{"id":109,"price":"2000","isActive":false,"status":"saled"},{"id":110,"price":"2000","isActive":false,"status":"saled"},{"id":111,"price":"2000","isActive":false,"status":"saled"},{"id":112,"price":"2000","isActive":false,"status":"saled"},{"id":113,"price":"2000","isActive":false,"status":"saled"},{"id":114,"price":"2000","isActive":false,"status":"saled"},{"id":115,"price":"2000","isActive":false,"status":"saled"},{"id":116,"price":"2000","isActive":false,"status":"saled"},{"id":117,"price":"2000","isActive":false,"status":"saled"},{"id":118,"price":"2000","isActive":false,"status":"saled"},{"id":119,"price":"2000","isActive":false,"status":"saled"},{"id":120,"price":"2000","isActive":false,"status":"saled"},{"id":121,"price":"2000","isActive":false,"status":"saled"},{"id":122,"price":"2000","isActive":false,"status":"saled"},{"id":123,"price":"2000","isActive":false,"status":"saled"},{"id":124,"price":"2000","isActive":false,"status":"saled"},{"id":125,"price":"2000","isActive":false,"status":"saled"},{"id":126,"price":"2000","isActive":false,"status":"saled"},{"id":127,"price":"2000","isActive":false,"status":"saled"},{"id":128,"price":"2000","isActive":false,"status":"saled"},{"id":129,"price":"2000","isActive":false,"status":"saled"},{"id":130,"price":"2000","isActive":false,"status":"saled"},{"id":131,"price":"2000","isActive":false,"status":"saled"},{"id":132,"price":"2000","isActive":false,"status":"saled"},{"id":133,"price":"2000","isActive":false,"status":"saled"},{"id":134,"price":"2000","isActive":false,"status":"saled"},{"id":135,"price":"2000","isActive":false,"status":"saled"},{"id":136,"price":"2000","isActive":false,"status":"saled"},{"id":137,"price":"2000","isActive":false,"status":"saled"},{"id":138,"price":"2000","isActive":false,"status":"saled"},{"id":139,"price":"2000","isActive":false,"status":"saled"},{"id":140,"price":"2000","isActive":false,"status":"saled"},{"id":141,"price":"2000","isActive":false,"status":"saled"},{"id":142,"price":"2000","isActive":false,"status":"saled"},{"id":143,"price":"2000","isActive":false,"status":"saled"},{"id":144,"price":"2000","isActive":false,"status":"saled"},{"id":145,"price":"2000","isActive":false,"status":"saled"},{"id":146,"price":"2000","isActive":false,"status":"saled"},{"id":147,"price":"2000","isActive":false,"status":"saled"},{"id":148,"price":"2000","isActive":false,"status":"saled"},{"id":149,"price":"2000","isActive":false,"status":"saled"},{"id":150,"price":"2000","isActive":false,"status":"saled"},{"id":151,"price":"2000","isActive":false,"status":"saled"},{"id":152,"price":"2000","isActive":false,"status":"saled"},{"id":153,"price":"2000","isActive":false,"status":"saled"},{"id":154,"price":"2000","isActive":false,"status":"saled"},{"id":155,"price":"2000","isActive":false,"status":"saled"},{"id":156,"price":"2000","isActive":false,"status":"saled"},{"id":157,"price":"2000","isActive":false,"status":"saled"},{"id":158,"price":"2000","isActive":false,"status":"saled"},{"id":159,"price":"2000","isActive":false,"status":"saled"},{"id":160,"price":"2000","isActive":false,"status":"saled"},{"id":161,"price":"2000","isActive":false,"status":"saled"},{"id":162,"price":"2000","isActive":false,"status":"saled"},{"id":163,"price":"2000","isActive":false,"status":"saled"},{"id":164,"price":"2000","isActive":false,"status":"saled"},{"id":165,"price":"2000","isActive":false,"status":"saled"},{"id":166,"price":"2000","isActive":false,"status":"saled"},{"id":167,"price":"2000","isActive":false,"status":"saled"},{"id":168,"price":"2000","isActive":false,"status":"saled"},{"id":169,"price":"2000","isActive":false,"status":"saled"},{"id":170,"price":"2000","isActive":false,"status":"saled"},{"id":171,"price":"2000","isActive":false,"status":"saled"},{"id":172,"price":"2000","isActive":false,"status":"saled"},{"id":173,"price":"2000","isActive":false,"status":"saled"},{"id":174,"price":"2000","isActive":false,"status":"saled"},{"id":175,"price":"2000","isActive":false,"status":"saled"},{"id":176,"price":"2000","isActive":false,"status":"saled"},{"id":177,"price":"2000","isActive":false,"status":"saled"},{"id":178,"price":"2000","isActive":false,"status":"saled"},{"id":179,"price":"2000","isActive":false,"status":"saled"},{"id":180,"price":"2000","isActive":false,"status":"saled"},{"id":181,"price":"2000","isActive":false,"status":"saled"},{"id":182,"price":"2000","isActive":false,"status":"saled"},{"id":183,"price":"2000","isActive":false,"status":"saled"},{"id":184,"price":"2000","isActive":false,"status":"saled"},{"id":185,"price":"2000","isActive":false,"status":"saled"},{"id":186,"price":"2000","isActive":false,"status":"saled"},{"id":187,"price":"2000","isActive":false,"status":"saled"},{"id":188,"price":"2000","isActive":false,"status":"saled"},{"id":189,"price":"2000","isActive":false,"status":"saled"},{"id":190,"price":"2000","isActive":false,"status":"saled"},{"id":191,"price":"2000","isActive":false,"status":"saled"},{"id":192,"price":"2000","isActive":false,"status":"saled"},{"id":193,"price":"2000","isActive":false,"status":"saled"},{"id":194,"price":"2000","isActive":false,"status":"saled"},{"id":195,"price":"2000","isActive":false,"status":"saled"},{"id":196,"price":"2000","isActive":false,"status":"saled"},{"id":197,"price":"2000","isActive":false,"status":"saled"},{"id":198,"price":"2000","isActive":false,"status":"saled"},{"id":199,"price":"2000","isActive":false,"status":"saled"},{"id":200,"price":"2000","isActive":false,"status":"saled"}]}],
        visible: true,
        check: false,
      },
    ],
    activities: [
      {
        id: 0,
        visible: true,
        title: 'Ужин с Константином',
        status: 'planning',
        statusText: 'планируется',
        city: 'Екатеринбург',
        place: 'Колизей Арена',
        date: '28 апреля 2020',
        time: '19:00',
        pin: false,
        avaColor: 'green',
        avaLetter: 'К',
        ava: '',
      },
      {
        id: 1,
        visible: true,
        title: 'Концерт группы «Пропаганда»',
        status: 'pause',
        statusText: 'приостановлено',
        city: 'Москва',
        place: 'Колизей Арена',
        date: '21 мая 2020',
        time: '19:00',
        pin: false,
        avaColor: 'blue',
        avaLetter: 'П',
        ava: '',
      },
      {
        id: 2,
        visible: true,
        title: 'Встреча с Сёминым',
        status: 'on-sale',
        statusText: 'в продаже',
        city: 'Санкт-Петербург',
        place: 'Колизей Арена',
        date: '23 ноября 2020',
        time: '19:00',
        pin: true,
        avaColor: 'fiolet',
        avaLetter: 'С',
        ava: 'ava1.png',
      },
      {
        id: 3,
        visible: true,
        title: 'Завтрак с Катериной',
        status: 'planning',
        statusText: 'планируется',
        city: 'Екатеринбург',
        place: 'Колизей Арена',
        date: '12 апреля 2020',
        time: '19:00',
        pin: false,
        avaColor: 'green',
        avaLetter: 'К',
        ava: '',
      },
    ],
    activitiesArchive: [
      {
        id: 1,
        visible: true,
        title: 'Концерт группы «Пропаганда»',
        status: 'cancel',
        statusText: 'отменено',
        city: 'Санкт-Петербург',
        place: 'Колизей Арена',
        date: '18 мая 2019',
        time: '19:00',
        pin: false,
        avaColor: 'blue',
        avaLetter: 'П',
        ava: '',
      },
      {
        id: 0,
        visible: true,
        title: 'Встреча с Константином',
        status: 'archive',
        statusText: 'архив',
        city: 'Санкт-Петербург',
        place: 'Колизей Арена',
        date: '28 ноября 2019',
        time: '19:00',
        pin: false,
        avaColor: 'green',
        avaLetter: 'К',
        ava: '',
      },
    ],
    newSector: {
      id: null,
      name: null,
      type: null,
      row: null,
      place: null,
      price: null,
      summ: null,
      status: null,
      scheme: null,
      visible: true,
      edit: false,
      valid: true,
    },
    newSectors: [],
    priceAll: ['Любая'],
    sectorAll: ['Любой'],
    statusAll: ['Любой'],
    documents: [
      {
        id: 498,
        visible: true,
        number: 'QW16546-098',
        date: '03.09.2020, 16:30',
        period: 'сентябрь 2020',
        status: 'Подписан',
        org: 'ООО «Гости»',
        report: true,
        upd: true,
        docs: [],
      }, {
        id: 250,
        visible: true,
        number: 'QW16546-098',
        date: '15.08.2020, 00:05',
        period: 'август 2020',
        status: 'Подписан',
        org: 'ООО «Гости»',
        report: true,
        upd: true,
        docs: ['IMG 1387.jpg', 'IMG 000589.jpg'],
      }, {
        id: 422,
        visible: true,
        number: 'QW16546-098',
        date: '03.09.2020, 16:30',
        period: 'сентябрь 2020',
        status: 'Подписан',
        org: 'ООО «Гости»',
        report: true,
        upd: true,
        docs: [],
      }, {
        id: 212,
        visible: true,
        number: 'QW16546-098',
        date: '15.08.2020, 00:05',
        period: 'август 2020',
        status: 'Подписан',
        org: 'ООО «Гости»',
        report: true,
        upd: true,
        docs: ['IMG 1387.jpg', 'IMG 000589.jpg'],
      }, {
        id: 472,
        visible: true,
        number: 'QW16546-098',
        date: '03.09.2020, 16:30',
        period: 'сентябрь 2020',
        status: 'Подписан',
        org: 'ООО «Гости»',
        report: true,
        upd: true,
        docs: ['IMG 1387.jpg', 'IMG 000589.jpg'],
      },
    ],
    withdrawal: [
      {
        id: 132789,
        visible: true,
        name: 'Название организатора, очень длинное',
        balance: 2905.25
      }, {
        id: 465791,
        visible: true,
        name: 'ООО "Музыкальный лейбл "Блэк Стар" ',
        balance: 15859.58
      }, {
        id: 13278,
        visible: true,
        name: 'ООО "Глобал Артист Эдженси"',
        balance: 2905.25
      }, {
        id: 465712,
        visible: true,
        name: 'Сектор без места',
        balance: 29222205.25
      }
    ]
  },
  getters: {
    hours: state => {
      return state.hours;
    },
    minutes: state => {
      return state.minutes;
    },
    cities: state => {
      return state.cities;
    },
    activityPlace: state => {
      return state.activityPlace;
    },
    sectors: state => {
      return state.sectors;
    },
    filters: state => {
      return state.filters;
    },
    activities: state => {
      return state.activities;
    },
    activitiesArchive: state => {
      return state.activitiesArchive;
    },
    sidebar: state => {
      return state.sidebar;
    },
    newSector: state => {
      return state.newSector;
    },
    newSectors: state => {
      return state.newSectors;
    },
    priceAll: state => {
      return state.priceAll;
    },
    sectorAll: state => {
      return state.sectorAll;
    },
    statusAll: state => {
      return state.statusAll;
    },
    documents: state => {
      return state.documents;
    },
    withdrawal: state => {
      return state.withdrawal;
    }
  },
  modules: {

  }
})

// utils functions
function sortFn(a, b) {
  if (a === 'Любой' || b === 'Любой') {
    return 0
  }
  a = a.toLowerCase()
  b = b.toLowerCase()
  if (a < b) {
    return -1
  }
  if (a > b) {
    return 1
  }
  return a < b;
}
function convertStatus(status) {
  switch (status) {
    case 'sale':
      status = 'Продаются'
      break;
    case 'locked':
      status = 'Заблокированы'
      break;
    case 'hide':
      status = 'Скрыты'
      break;
    case 'saled':
      status = 'Проданы'
      break;
    case 'reserve':
      status = 'Пригласительные'
      break;
    case 'Любой':
      status = 'Любой'
      break;
    default: status = null
      break;
  }
  return status;
}